module.exports = __webpack_public_path__ + "static/media/reachedTournamentTop10_75_100.8ea9f7bb.png";